import React from 'react';
import { Navbar } from '../components/fusion';
import CAIAvatarMenu from './CAIAvatarMenu';
import env from '../configs/envConfig';
import { debugLog } from '../configs/loggingConfig';

const NavbarFactory = ({ navbarKey, children }) => {
    const navbarSettings = navbarConfig[navbarKey];

    if (!navbarSettings) {
        debugLog.error(`Invalid navbarKey (${navbarKey}) provided.`);
        return null;
    }

    return (
        <Navbar
            appTitle={navbarSettings.appTitle}
            appTitleSuffix={navbarSettings.appTitleSuffix}
            appSubtitle={navbarSettings.appSubtitle}
            navigations={navbarSettings.navigations}
        >
            <CAIAvatarMenu />
            {children}
        </Navbar>
    );
};

export default NavbarFactory;



export const navbarConfig = {
    // When in doubt, render no app title or navs.
    default: {
        appTitle: "",
        navigations: []
    },
    adminSettings: {
        appTitle: "Admin Settings",
        navigations: []
    },
    bonus: {
        appTitle: "Bonus Planning",
        navigations: [
            {
                path: "/bonus",
                title: "My Organizations",
            },
        ]
    },
    payroll: {
         appTitle: "Payroll Planning",
         navigations: [
             {
                 path: "/payroll",
                 title: "My Organizations",
             },
         ]
    },
    settings: {
        appTitle: "Settings",
        navigations: []
    },
    forms: {
        appTitle: "Forms",
        navigations: []
    },
    maestro: {
        appTitle: env.REACT_APP_BRANDING_SYMPHONY_TITLE ?? "Maestro",
        appTitleSuffix: env.REACT_APP_BRANDING_SYMPHONY_TITLE_SUFFIX ?? "",
        appSubtitle: env.REACT_APP_BRANDING_SYMPHONY_SUBTITLE ?? "",
        navigations: env.REACT_APP_ALLEGRO_HIDE_NAVBAR === "true" ? [] : [
            {
                path: `/${env.REACT_APP_BRANDING_APP_PATH ?? "maestro"}/chat`,
                title: "Chat",
            },
            {
                path: `/${env.REACT_APP_BRANDING_APP_PATH ?? "maestro"}/data`,
                title: "Data Collections",
            },
            {
                path: `/${env.REACT_APP_BRANDING_APP_PATH ?? "maestro"}/templates`,
                title: "Templates"
            },
            {
                path: `/settings/${env.REACT_APP_BRANDING_APP_PATH ?? "maestro"}`,
                title: "App Settings",
            },
        ]
    },
    sift: {
        appTitle: env.REACT_APP_BRANDING_SIFT_TITLE ?? "Sift",
        appTitleSuffix: env.REACT_APP_BRANDING_SIFT_TITLE_SUFFIX ?? "2",
        appSubtitle: env.REACT_APP_BRANDING_SYMPHONY_SUBTITLE ?? "",
        navigations: [
            {
                path: `/${process.env.REACT_APP_BRANDING_SIFT_PATH ?? "sift"}`,
                title: "Opportunities"
            },
            //{
            //    path: `/${process.env.REACT_APP_BRANDING_SIFT_PATH ?? "sift"}/types`,
            //    title: "Opportunity Types"
            //}
        ]
    },
    pcya: {
        appTitle: "PCYA",
        appTitleSuffix: "-OCYF",
        appSubtitle: "Powered by CAI",
        navigations: []
    }
};